import { trpc } from "@/lib/trpc";
import type { PainelChave } from "../painel/painel-tipos";

export const ROTULO_DO_PAINEL: Record<PainelChave, string> = {
  equipe: "Equipe",
  pacientes: "Pacientes",
  agenda: "Agenda",
  protese: "Pedidos de prótese",
  pendentes: "Aguardando aceite",
  producao: "Em produção",
  atrasados: "Atrasados",
  resumo: "Resumo por prazo",
};

/** Os painéis que o papel da pessoa alcança naquela organização: o preview devolve nulo onde não. */
export function usePaineisDisponiveis(organizationId: string) {
  const preview = trpc.organization.getOrgPreview.useQuery({ organizationId }).data;
  const paineis: PainelChave[] = preview
    ? ([
        preview.teamCount !== null && "equipe",
        preview.patientCount !== null && "pacientes",
        preview.consultasMarcadasCount !== null && "agenda",
        preview.types.includes("DENTAL_OFFICE") && preview.pedidosCount !== null && "protese",
        ...(preview.prazo ? (["pendentes", "producao", "atrasados", "resumo"] as const) : []),
      ].filter(Boolean) as PainelChave[])
    : [];
  return { preview, paineis };
}
